import React, { Component } from 'react';
import './html.css';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';


class Html extends Component {

    state = {
       value: {
           __html: this.props.initialValues.value || ''
       }
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            value: this.state.value.__html
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    render() {
        const { value } = this.state;
        return (
            <div className="custom-html_element">
                <div className="html-wrapper result-input" dangerouslySetInnerHTML={value} />
                {
                    !this.props.isResultInput &&
                    <textarea
                        value={this.state.value.__html}
                        onChange={e => this.setState({ value: { __html: e.target.value } })}
                        cols="30" rows="10"
                    />
                }
            </div>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Html)